import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class FavouritesService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    favourite(id: string, entity: SystemEntity): Observable<object> {
        return this.http.patch(
            `${
                this.config.getConfiguration().API_BASE
            }/useraction/favourite/entity/${entity}/${id}`,
            {},
        );
    }

    unfavourite(id: string, entity: SystemEntity): Observable<object> {
        return this.http.patch(
            `${
                this.config.getConfiguration().API_BASE
            }/useraction/unfavourite/entity/${entity}/${id}`,
            {},
        );
    }
}
